<template>
  <div class="job-card">
    <div>
      <div class="job-card-header">
        <div class="job-card-title">
          <h3>{{ job.role_title }}</h3>
          <span class="badge">{{ job.industry.name }}</span>
        </div>
      </div>
      <div class="job-card-body">
        <div
          class="content"
          v-html="job.job_description"
        />
      </div>
      <div class="job-card-skills">
        <p class="title">Required skills</p>
        <ul>
          <li
            v-for="skill in job.skills"
            :key="`${job.id}-${skill.id}`"
            class="skill badge"
          >
            {{ skill.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="job-card-footer">
      <div class="job-card-footer-item">
        <p class="title">Stack</p>
        <p>{{ job.skill_stack.name }}</p>
      </div>
      <div class="job-card-footer-item">
        <p class="title">Commitment</p>
        <p>{{ job.commitment_type }}</p>
      </div>
      <div class="job-card-footer-item">
        <p class="title">Duration</p>
        <p>{{ job.duration }}</p>
      </div>
      <div
        v-if="job.country"
        class="job-card-footer-item"
      >
        <p class="title">Country</p>
        <p>
          <img
            class="flag"
            :src="getFlagSvg(job.country.code)"
            :alt="`${job.country.name} flag`"
          />
          {{ job.country.name }}
        </p>
      </div>
    </div>
    <ApplyButton
      cta-section="job-card"
      class="proxify-btn btn-full"
      :additional-data="{ app_recruitment_id: job.app_recruitment_id }"
    />
  </div>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: { ApplyButton },
  props: {
    job: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    getFlagSvg(countryCode) {
      try {
        return `/images/icons/flags/${countryCode}.svg`;
      } catch {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './JobCard.scss';
</style>
